import React from 'react';
import { siteConfig } from '../config/siteConfig';
import ScrollingTitle from '../components/ScrollingTitle/ScrollingTitle';
import './Page.css';

const OsterreichischesFilmservice = () => {
  const { osterreichischesFilmservice } = siteConfig;

  return (
    <div className="osterreichisches-filmservice-page">
      <ScrollingTitle lines={osterreichischesFilmservice.title.lines} />
      
      <div className="osterreichisches-filmservice-content">
        <div className="osterreichisches-filmservice-container">
          
          {/* Main Content Grid */}
          <div className="osterreichisches-main-grid">
            
            {/* Contact Section */}
            <div className="osterreichisches-contact">
              {/* Description */}
              <div className="osterreichisches-description">
                <p>{osterreichischesFilmservice.contact.description}</p>
              </div>
              
              <h2 className="osterreichisches-contact-title">{osterreichischesFilmservice.contact.title}</h2>
              <h3 className="osterreichisches-contact-name">{osterreichischesFilmservice.contact.name}</h3>
              <div className="osterreichisches-contact-email">
                <i className={osterreichischesFilmservice.contact.email.icon}></i>
                <a href={osterreichischesFilmservice.contact.email.link}>
                  {osterreichischesFilmservice.contact.email.display}
                </a>
              </div>
            </div>
            
            {/* Map Section */}
            <div className="osterreichisches-map">
              <a 
                href={osterreichischesFilmservice.map.googleMapsUrl} 
                target="_blank" 
                rel="noopener noreferrer"
                className="osterreichisches-map-link"
              >
                <img 
                  src={osterreichischesFilmservice.map.image.src} 
                  alt={osterreichischesFilmservice.map.image.alt} 
                />
              </a>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default OsterreichischesFilmservice; 